import OverlayWindow, {
  PaddingSize,
  WindowSize,
} from 'Components/OverlayWindow';
import { ReactNode } from 'react';

export default function SelectInputWindow({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <OverlayWindow
      size={WindowSize.full}
      paddingSize={PaddingSize.none}
      border="border border-gray-100"
      rounded="rounded"
    >
      {children}
    </OverlayWindow>
  );
}
